import { baseLinks } from './baseLinks';
import { DrawerListLink } from './drawer.types';

export const userLinks: DrawerListLink[] = [...baseLinks];
